import {
    ApiFinalizeParamsType,
    apiFinalizeRequest,
    ApiFinalizeResponseType,
} from 'src/api_openapi/v2/idMission/apiFinalize';
import { apiGetSessionIdRequest, ApiGetSessionIdResponseType } from 'src/api_openapi/v2/idMission/apiGetSessionId';
import {
    apiVerifyProgressRequest,
    ApiVerifyProgressResponseType,
} from 'src/api_openapi/v2/idMission/apiVerifyProgress';
import { ApiManualTriggerResponseType, apiManualTriggerRequest } from 'src/api_openapi/v2/idMission/apiManualTrigger';
import { Common } from 'src/domains/common/Common';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';
import { IdmissionSDKType } from './IdMissionPopup/IdMissionPopup';

export class IdentityAPI {
    public static get = AutoWeakMap.create((common: Common) => new IdentityAPI(common));

    private constructor(private readonly common: Common) {}

    public getSessionId = async (): Promise<ApiGetSessionIdResponseType> => {
        if (this.common.envVariables.gatewayApiHost === null) {
            throw new Error('Unknown gatewayApiHost');
        }

        const token = this.getToken();
        return await apiGetSessionIdRequest(
            this.common.envVariables.gatewayApiHost,
            {},
            {
                authorization: `Bearer ${token}`,
            }
        );
    };

    public getToken = (): string => {
        const isAuthorized = this.common.session.isAuthorized;
        const token = isAuthorized
            ? this.common.session.currentJwt
            : this.common.session.ephemeralAccessValue?.ephemeralToken.get();
        if (token === undefined) {
            throw new Error('Token is not valid');
        }
        return token;
    };

    public runManualTrigger = async (
        account_id: number,
        verificationVariant: IdmissionSDKType
    ): Promise<ApiManualTriggerResponseType> => {
        if (this.common.envVariables.gatewayApiHost === null || this.common.envVariables.apiUniverse === null) {
            throw new Error('Unknown gatewayApiHost');
        }

        return await apiManualTriggerRequest(
            this.common.envVariables.gatewayApiHost,
            {
                requestBody: {
                    accountId: account_id,
                    verificationVariant: verificationVariant,
                    universe: this.common.envVariables.apiUniverse,
                    triggerReason: 'website',
                },
            },
            {
                authorization: `Bearer ${this.getToken()}`,
            }
        );
    };

    public getVerifyProgress = async (account_id: number): Promise<ApiVerifyProgressResponseType> => {
        if (this.common.envVariables.gatewayApiHost === null) {
            throw new Error('Unknown gatewayApiHost');
        }

        return await apiVerifyProgressRequest(
            this.common.envVariables.gatewayApiHost,
            {
                account_id,
            },
            {
                authorization: `Bearer ${this.getToken()}`,
            }
        );
    };

    public postFinalizeRequest = async (params: ApiFinalizeParamsType): Promise<ApiFinalizeResponseType> => {
        if (this.common.envVariables.gatewayApiHost === null) {
            throw new Error('Unknown gatewayApiHost');
        }

        return await apiFinalizeRequest(this.common.envVariables.gatewayApiHost, params, {
            authorization: `Bearer ${this.getToken()}`,
        });
    };
}
